import React from 'react';
import BudgetBoard from './view_budget_board';
import BudgetDetailed from './view_budget_detailed';
import BudgetManage from './view_budget_manage';

const BudgetMain = ({ activeTabL1, yearsRange }) => {
  return (
    <div className="w-full flex flex-col gap-2">
      {activeTabL1 === 'board' && (
        <div className="w-full mt-2">
          <BudgetBoard yearsRange={yearsRange} />
        </div>
      )}
      {activeTabL1 === 'detailed' && <BudgetDetailed />}
      {activeTabL1 === 'manage' && <BudgetManage />}
    </div>
  );
};

export default BudgetMain;
